import { PRECAMPAIGN_PAGE_KEY } from '../constants';

const translations = {
  en: {
    [PRECAMPAIGN_PAGE_KEY]: {
      HERO_TITLE: 'Black Friday Sale at Crehana',
      HERO_SUBTITLE:
        'Lorem ipsum dolor sit amet. Ex distinctio exercitationem ea aliquid ducimus non fugit culpa ',
      HERO_DATE: 'November 24th and 25th, 2021',
      REGISTER_FORM_TITLE: 'Be the first to know about the Black Friday sales',
      AUTH_WITH_EMAIL: 'or Register with email',
      AUTH_WITH_SOCIALNET: 'or register with social networks',
      AGREE_TYC: 'By signing up you agree to our ',
      LINK_TYC: 'Terms and Privacy Policy.',
      START_FREE_TRIAL: 'Start your free trial',
      PRODUCTS_PAYG_TITLE: 'Over 800 courses in 22 categories',
      PRODUCTS_PAYG_SUBTITLE:
        'Learn with experts in Marketing, Business, Design, Video, Photography and more to stay updated on the most trending topics.',
      PRODUCTS_PACKS_TITLE: 'Build your course pack',
      PRODUCTS_PACKS_SUBTITLE:
        'Combine them as you like and build the ideal course pack to grow in your professional career, entrepreneurship or hobbies.',
      PRODUCTS_PREMIUM_TITLE: 'Premium Plans',
      PRODUCTS_PREMIUM_SUBTITLE:
        'Get full access to all our courses, advice and personalized attention for 1 year. Choose the perfect plan for you or to share!',
      SEE_MORE: 'See more',
      PRODUCTS_MICRODEGREE_TITLE: 'Learn with the best universities',
      PRODUCTS_MICRODEGREE_SUBTITLE:
        'The MicroDegree is a 4-month online program, co-certified with top universities in Latin America, on specialized topics with high demand in the market.',
      MICRODEGREE_PRODUCT_MANAGEMENT: 'MicroDegree in Product Management',
      MICRODEGREE_MARKETING: 'MicroDegree in Digital Marketing',
      MICRODEGREE_UXUI: 'MicroDegree in Data Analytics',
      MICRODEGREE_DATA: 'MicroDegree in UX/UI',
      MICRODEGREE_SLIDER_SUBTITLE: 'More than 800 courses in 22 categories',
      MICRODEGREE_CARD_PRIMARY_BUTTON: 'Join now',
      MICRODEGREE_CARD_SECONDARY_BUTTON: 'Learn more',

      FAQ_TITLE: 'Frequently Asked Questions',

      PROMO_ENDS: 'This promotion ends in:',

      PACKS_TITLE: 'Build your course pack',
      PACKS_SUBTITLE:
        'Combine them as you like and build the ideal course pack to grow in your professional career, entrepreneurship or hobbies.',
      PACKS_STEP1: '1. Choose your courses',
      PACKS_STEP2: '2. Build your pack',
      PACKS_STEP3: '3. Click “Purchase”',

      PREMIUM_CTA: 'Upgrade to Premium',
      DEGREE_STARTS_ON: 'Starts on',
    },
  },
};

export default translations;
